/* global Vue, primevue, BOOKING_APP_URI, PREFIX, AlgoliaEvents */

import { BookingParams } from '../classes/BookingParams'
import BookingModal from './components/BookingModal'
import { CreateI18n } from '../i18n/create-i18n'
import { messagesSpecific } from '../i18n/translations'
import '../validation-rules'

const i18n = CreateI18n(messagesSpecific)

let phobsId

const BookingBarApp = Vue.createApp({
  name: 'BookingBarApp',
  components: { BookingModal },
  template: `
<div class="booking-bar">
  <button class="button button--primary hide-md-up" @click="openCheckRates(3)">
    {{ $t('bookNow') }}
  </button>

  <div class="booking-bar__wrapper hide-md-down">
    <button class="booking-bar__button" @click="openCheckRates(3)">
      {{ bookingParams.displayDate }}
      <i class="icon-caret-down"></i>
    </button>

    <button class="booking-bar__button" @click="openCheckRates(4)">
      {{ bookingParams.displayGuests($t) }}
      <i class="icon-caret-down"></i>
    </button>

    <button @click="bookNow()" class="button button--primary" v-text="$t('bookNow')" />
  </div>
</div>
  `,
  setup () {
    const bookingParams = Vue.reactive(new BookingParams())

    function bookNow () {
      if (AlgoliaEvents) {
        AlgoliaEvents.convertedFilters({
          eventName: 'Booking Intent',
          ...AlgoliaEvents.propertyParamsCache,
        })
      }
      window.location.href = `${BOOKING_APP_URI}${PREFIX}/step1?propertyId=${phobsId}&${bookingParams.urlString}`
    }

    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    parseQueryParams(params)

    function parseQueryParams ({ accessCode, adults, children }) {
      if (adults != null) bookingParams.adults = parseInt(adults)
      if (children != null) bookingParams.children = children.split(',').map(age => ({ age: parseInt(age) }))
      if (accessCode != null) bookingParams.accessCode = accessCode
    }

    function openCheckRates (step) {
      window.location = `#/check-rates?propertyId=${phobsId}&step=${step}`
    }

    return {
      BOOKING_APP_URI,
      phobsId,
      bookingParams,
      bookNow,
      openCheckRates,
    }
  },
})

const appElement = document.getElementById('booking-bar-app')

if (appElement) {
  phobsId = appElement.dataset.phobsId
  BookingBarApp.use(i18n)
  BookingBarApp.use(primevue)
  BookingBarApp.mount(appElement)
}

export default BookingBarApp
